// removed by extract-text-webpack-plugin
module.exports = {"list":"groupsList__list__1y9HA","item":"groupsList__item__2s64S","delete":"groupsList__delete__1cMKq","fake":"groupsList__fake__13Y3Q","triangle":"groupsList__triangle__2Uph-"};


//////////////////
// WEBPACK FOOTER
// ./src/groupsList/groupsList.scss
// module id = 21
// module chunks = 0